<template>
  <section class="container">
    <span v-html="title"></span>

    <div id="faqs-container">
      <FaqItem
        :question="faq.question"
        :answer="faq.answer"
        v-for="faq in faqs"
      />
    </div>
  </section>
</template>
<script setup lang="ts">
/** The FAQ  section for a page, a lot in the FAQ block is using `v-html`, because the content is inserted as rich text from the backend.
 */

const props = defineProps<{
  title?: string;
  faqs: Array<{ question: string; answer: string }>;
}>();

// Let's insert Schema.org structure for a FAQ in the head.
const jsonLD = computed(() => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: props.faqs.map((faq: { question: string; answer: string }) => ({
    "@type": "Question",
    name: faq.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: faq.answer,
    },
  })),
}));

useHead({
  script: [
    {
      type: "application/ld+json",
      innerHTML: JSON.stringify(jsonLD.value),
      tagPosition: "bodyClose",
    },
  ],
});
</script>
<style scoped>
.container {
  margin-bottom: 3rem;
}

#faqs-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
